











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Location } from 'vue-router'
import type { Atualizacao } from '@/shareds/novidades/modelo'
import { contagem, itensRestantes, parteDoMes } from '@/shareds/novidades/modelo'
import EtiquetaDeArea from './EtiquetaDeArea.vue'

const ITENS_NO_CARTAO = 6

@Component({ components: { EtiquetaDeArea } })
export default class CartaoDaAtualizacao extends Vue {
	@Prop({ type: Object, required: true }) atualizacao!: Atualizacao
	/** Itens em que a busca achou o termo; vazio fora da busca. */
	@Prop({ type: Array, default: () => [] }) itensAchados!: number[]

	get parte() {
		return parteDoMes(this.atualizacao)
	}

	get contagem() {
		return contagem(this.atualizacao)
	}

	get primeiros() {
		return this.atualizacao.itens.slice(0, ITENS_NO_CARTAO)
	}

	get achados() {
		return this.atualizacao.itens.filter(i => this.itensAchados.includes(i.ordem))
	}

	get restantes() {
		if (this.achados.length) return ''
		return itensRestantes(this.atualizacao, this.primeiros.length)
	}

	rota(item?: number): Location {
		return {
			name: 'Novidade',
			params: { id: this.atualizacao.id },
			query: item ? { item: String(item) } : {},
		}
	}
}
